import { getManagement } from '@/shared/restActions';

function getCountriesList() {
  return getManagement('/api/v2/countries');
}

export default {
  getCountriesList,
};
